module.exports = __webpack_public_path__ + "static/media/business.f1dbcd73.svg";